// ClassName for links in the receiver side. This is for reply with original thread or forward.
export const X_OWA_AUTO_LINKS_CLASSNAME = 'x_OWAAutoLink';
export const ANCHOR_TAG_NAME = 'a';
export const IMG_TAG_NAME = 'img';
export const SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME = 'originalsrc';
export const SPINNER_CLASSNAME = 'OWALinkSpinner';

// The prefix must start with OLK to avoid CTS(content transformation service) from appending x_ in front.
export const OUTLOOK_BEAUTIFIED_PREFIX = 'OLK_Beautified_';

// The content change source for upgrading compose
export const UPGRADE_CHANGE_SOURCE = 'UpgradeCompose';

export const LINK_TEMP_ZERO_WIDTH_SPACE_CLASS = 'LINK_TEMP_INSERTED_CLASS';
